module.exports = __webpack_public_path__ + "img/gq5.64095621.png";